import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getWorkOrderFormActions = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/work-order-form-actions`);
    return response.data;
  } catch (error) {
    console.error('Error fetching work-order-form-actions:', error.response?.data || error);
    throw error;
  }
};

export const getWorkOrderFormActionsByWorkOrderFormId = async (workOrderFormId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/work-order-form-actions/work-order-form/${workOrderFormId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching work-order-form-actions by workOrderFormId:', error.response?.data || error);
    throw error;
  }
};

export const getWorkOrderFormActionById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/work-order-form-actions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching work-order-form-action:', error.response?.data || error);
    throw error;
  }
};

export const createWorkOrderFormAction = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/work-order-form-actions`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating work-order-form-action:', error.response?.data || error);
    throw error;
  }
};

export const updateWorkOrderFormAction = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/work-order-form-actions/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating work-order-form-action:', error.response?.data || error);
    throw error;
  }
};

export const deleteWorkOrderFormAction = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/work-order-form-actions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting work-order-form-action:', error.response?.data || error);
    throw error;
  }
};
